import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'
import usePausaStore from '@/store/pausas'

export function clearStores() {
  const { clear: clearAuthStore } = useAuthStore()
  const { clear: clearUserStore } = useUserStore()
  const pausaStore = usePausaStore()

  clearAuthStore()
  clearUserStore()

  /*
   * usePausaStore é persistido no localStorage e nunca era limpo aqui: depois de qualquer logout
   * (expiração de token, deslogado pelo gestor, logout manual), o timer de uma pausa de uma sessão
   * já encerrada sobrevivia e reaparecia no próximo login -- uma sessão nova com resquício de uma
   * pausa antiga.
   */
  clearInterval(pausaStore.timerInterval)
  pausaStore.$reset()
}
